/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateNoteMentionableUsers } from '../../axios/candidateNoteMentionableUsers'
import type {
	CandidateNoteMentionableUsersError,
	CandidateNoteMentionableUsersPathParams,
	CandidateNoteMentionableUsersResponse,
} from '../../types/CandidateNoteMentionableUsers'

export const candidateNoteMentionableUsersQueryKey = (
	candidate: CandidateNoteMentionableUsersPathParams['candidate'],
) => [{ url: '/candidates/:candidate/mentionable-users', params: { candidate } }] as const

export type CandidateNoteMentionableUsersQueryKey = ReturnType<typeof candidateNoteMentionableUsersQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::mentionableUsers */
export function candidateNoteMentionableUsersQueryOptions(
	candidate: CandidateNoteMentionableUsersPathParams['candidate'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CandidateNoteMentionableUsersResponse,
		AxiosError<CandidateNoteMentionableUsersError>,
		CandidateNoteMentionableUsersResponse,
		CandidateNoteMentionableUsersQueryKey
	>({
		queryKey: candidateNoteMentionableUsersQueryKey(candidate),
		queryFn: ({ signal }) => candidateNoteMentionableUsers(candidate, { signal, ...config }).then(res => res.data),
		enabled: !!candidate,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::mentionableUsers */
export function useCandidateNoteMentionableUsers<TSelectData = CandidateNoteMentionableUsersResponse>(
	candidate: CandidateNoteMentionableUsersPathParams['candidate'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidateNoteMentionableUsersResponse,
					AxiosError<CandidateNoteMentionableUsersError>,
					TSelectData,
					CandidateNoteMentionableUsersQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidateNoteMentionableUsersError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidateNoteMentionableUsersQueryOptions(candidate),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::mentionableUsers */
export function useCandidateNoteMentionableUsersSuspense<TSelectData = CandidateNoteMentionableUsersResponse>(
	candidate: CandidateNoteMentionableUsersPathParams['candidate'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidateNoteMentionableUsersResponse,
					AxiosError<CandidateNoteMentionableUsersError>,
					TSelectData,
					CandidateNoteMentionableUsersQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidateNoteMentionableUsersError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidateNoteMentionableUsersQueryOptions(candidate),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
